// First input delay https://github.com/GoogleChromeLabs/first-input-delay

export default function onFirstInputDelay() {
    return new Promise((resolve, reject) => {
        if (window.perfMetrics && window.perfMetrics.onFirstInputDelay) {
            window.perfMetrics.onFirstInputDelay((delay, event) => {
                resolve({ delay, event });
            });
        } else {
            reject(new Error('onFirstInputDelay is undefined'));
        }
    });
}
